var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flix-container"},[(_vm.users && _vm.users.length)?_c('userList',{attrs:{"users":_vm.users}}):_c('b-flix-alert',{attrs:{"variant":"danger"}},[_vm._v(_vm._s(_vm.$tc('message.noEntry', 2)))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }